import { useEffect } from 'react';
import { getOptimizelyVariant } from './optimizelyExperiments.js';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/index.js';
import { experimentVariantSelector, setExperimentVariant, } from './experimentsSlice.js';
/**
 * Custom hook to get and manage the active variant of an Optimizely A/B test.
 *
 * - Retrieves the experiment variant from the Redux state.
 * - If the variant is not set, it fetches it using `getOptimizelyVariant` and updates the store.
 * - Defaults to `'A'` if no active variant is found.
 *
 * @param {ExperimentKey} experimentName - The name of the Optimizely experiment.
 * @returns {string} The active variant (`'A'` or `'B'`).
 *
 * @example
 * const variant = useOptimizelyExperiment(KRK_569);
 * if (variant === 'B') {
 *   // Render experiment-specific case
 * }
 */
export const useOptimizelyExperiment = (experimentName) => {
    const dispatch = useAppDispatch();
    const variant = useAppSelector((state) => experimentVariantSelector(state, experimentName));
    useEffect(() => {
        if (!variant) {
            const newVariant = getOptimizelyVariant(experimentName);
            if (newVariant) {
                dispatch(setExperimentVariant({ name: experimentName, variant: newVariant }));
            }
        }
    }, [dispatch, experimentName, variant]);
    return variant;
};
//# sourceMappingURL=useOptimizelyExperiment.js.map